export default {
  methods: {
    routerErrorHandler(error) {
      let errPfx = this.$t('errorPrefix')
      this.$toast.error(`${errPfx}: ${error.msg} (code: ${error.code})`)
    },
  },
}
